'use client';
import { Button, CircularProgress } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useCart, useSimpleMutation } from '@peerless/ui-shared';

interface Props {
  sku: string;
  accessorySku?: string;
}

export const AddToCartButton: React.FC<Props> = ({ sku, accessorySku }: Props) => {
  const t = useTranslations();
  const { addProductToCart } = useCart();

  const { mutate, isPending } = useSimpleMutation(addProductToCart, [sku, accessorySku]);

  const handleAddToCart = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const skus = accessorySku ? [sku, accessorySku] : [sku];
    mutate(skus);
  };

  return (
    <Button fullWidth variant="outlined" onClick={handleAddToCart}>
      {isPending ? <CircularProgress size={24} /> : t('Cart.add-to-cart')}
    </Button>
  );
};
